<template>
  <div class="mail-body-content">
    <div class="mail-content-info" v-if="selected_email != null">
      <div class="mail-item-info-sender">
        <label class="sender">{{ $t('components.email.sender') }}</label> {{ getSender() }}
      </div>
      <div class="mail-item-info-recipient">
        <label class="recipient">{{ $t('components.email.recipient') }}</label> {{ getRecipient() }}
      </div>
      <div class="mail-item-info-title">
        <label class="title">{{ $t('components.email.title') }}</label> {{ getSubject() }}
      </div>
      <div class="mail-item-info-created">
        <label class="created">{{ $t('components.email.created') }}</label> {{ getDate() }}
      </div>
    </div>
    <div class="mail-content-txt" v-if="selected_email != null">
      <div v-if="selected_email.email.body.contentType == 'html'" v-html="sanitizedBody"></div>
      <div v-else>{{ selected_email.email.body.content }}</div>
    </div>
    <email-attachments-bottom v-if="selected_email" :attachments="selected_email.attachments" />

    <div v-if="!selected_email && is_loading"  class="empty-email-body">
        {{ $t('components.email.loading') }}
    </div>
    <div v-else-if="!selected_email && !is_empty_folder" class="empty-email-body">
        {{ $t('components.email.select_email') }}
    </div>
      <div v-else-if="!selected_email && !is_loading && is_empty_folder" class="empty-email-body">
        <email-empty-results :folder="folder" />
    </div>

  </div>
</template>

<script>
import DOMPurify from 'dompurify'
import EmailAttachmentsBottom from './EmailAttachmentsBottom.vue'
import EmailEmptyResults from './EmailEmptyResults.vue'

// Reusable sanitization config (created once, not on every call)
const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ['p', 'br', 'div', 'span', 'a', 'b', 'i', 'u', 'strong', 'em',
                 'ul', 'ol', 'li', 'table', 'tr', 'td', 'th', 'thead', 'tbody',
                 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'blockquote', 'pre', 'code'],
  ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'style', 'target', 'width', 'height'],
  ALLOW_DATA_ATTR: false,
};

export default {
  components: { EmailAttachmentsBottom, EmailEmptyResults },
  props: {
    selected_email: {
      type: Object,
      default: null
    },
    is_empty_folder: {
      type: Boolean,
      default: false
    },
    folder: {
      type: String,
      default: "Inbox"
    },
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Cache for sanitized body content
      cachedSanitizedBody: '',
      cachedEmailId: null,
    };
  },
  computed: {
    // Get current email ID for cache comparison
    currentEmailId: function() {
      if (!this.selected_email || !this.selected_email.email) {
        return null;
      }
      return this.selected_email.email.id || null;
    },
    sanitizedBody: function() {
      // Return cached value if email hasn't changed
      if (this.cachedEmailId === this.currentEmailId && this.cachedSanitizedBody) {
        return this.cachedSanitizedBody;
      }
      return this.computeSanitizedBody();
    }
  },
  watch: {
    // Update cache when selected email changes
    currentEmailId: {
      immediate: true,
      handler: function(newId) {
        if (newId !== this.cachedEmailId) {
          this.cachedEmailId = newId;
          this.cachedSanitizedBody = this.computeSanitizedBody();
        }
      }
    }
  },
  methods: {
    computeSanitizedBody: function() {
      if (!this.selected_email || !this.selected_email.email || !this.selected_email.email.body || !this.selected_email.email.body.content) {
        return '';
      }
      // Sanitize HTML to prevent XSS attacks
      return DOMPurify.sanitize(this.selected_email.email.body.content, SANITIZE_CONFIG);
    },
    getSender: function() {
      if (!this.selected_email || !this.selected_email.email || !this.selected_email.email.sender || !this.selected_email.email.sender.emailAddress) {
        return '';
      }
      var emailAddr = this.selected_email.email.sender.emailAddress;
      return emailAddr.name ? emailAddr.address + ' (' + emailAddr.name + ')' : emailAddr.address;
    },
    getRecipient: function() {
      if (!this.selected_email || !this.selected_email.email || !this.selected_email.email.toRecipients) {
        return '';
      }
      return this.selected_email.email.toRecipients
        .map(function(p) {
          var emailAddr = p.emailAddress;
          return emailAddr.name ? emailAddr.address + ' (' + emailAddr.name + ')' : emailAddr.address;
        })
        .join(", ");
    },
    getSubject: function() {
      if (!this.selected_email || !this.selected_email.email || !this.selected_email.email.subject) {
        return '';
      }
      return this.selected_email.email.subject;
    },
    getDate: function() {
      if (!this.selected_email || !this.selected_email.email || !this.selected_email.email.createdDateTime) {
        return '';
      }
      return new Date(this.selected_email.email.createdDateTime).toLocaleString();
    }
  }
}
</script>

<style></style>
